<!-- Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. -->

<div class="convert-to-pdf-wrapper">
  <div class="searchable-wrapper">
    <xrx-toggle-switch
      [ngClass]="{ expanded: searchable && isMfd }"
      label="SDE_SEARCHABLE"
      [switchOn]="searchable"
      glyph="xgl-search"
      [isMfd]="isMfd"
      (toggle)="searchToggle($event)">
    </xrx-toggle-switch>
    @if (isMfd) {
      <div>
        @if (searchable) {
          <xrx-popover
            label="SDE_INPUT_LANGUAGE"
            [showLabel]="true"
            [list]="list"
            [name]="'language'"
            [showIcon]="true"
            [(selectedValue)]="selectedItem"
            (change)="languageSelected($event)"
            [error]="setting.error">
          </xrx-popover>
        }
      </div>
    }
    @if (!isMfd) {
      <div class="input-language">
        @if (searchable) {
          <xrx-select
            label="SDE_INPUT_LANGUAGE"
            inlineLabel="SDE_LANGUAGE"
            [list]="list"
            [localize]="'key'"
            [property]="'value'"
            [orderby]="'key'"
            [(selectedItem)]="selectedItem"
            [isInputOnly]="true"
            [isMfd]="isMfd"
            (change)="languageSelected($event)"
            [error]="setting.error">
          </xrx-select>
        }
      </div>
    }
  </div>

  <xrx-toggle-switch
    label="SDE_ARCHIVAL_PDFA"
    [switchOn]="pdfA"
    glyph="xgl-file_pdfa"
    [isMfd]="isMfd"
    (toggle)="pdfAToggle($event)">
  </xrx-toggle-switch>
</div>
